import { FlexContainer, Text } from '@taxdown/piccolo-web';
import { FRONT_PLANS, plansNameMapping, plansLogos } from 'Constants/plans';
import { CustomerType } from 'Types/common';
import * as Styled from './styles';

const defaultPlan = FRONT_PLANS.BASIC;

const Header = ({ subscription }: { subscription: CustomerType }): JSX.Element => {
  const activePlan = subscription?.activePlan;
  const planName = plansNameMapping(activePlan?.name) || defaultPlan;

  return (
    <Styled.Container $planName={planName} direction="column" gap="dimension_16">
      <FlexContainer align="center" gap="dimension_16">
        <img src={plansLogos[planName]} alt="logo" />
        <Text type="headline" size="S_L_S" color="dark">
          {planName}
        </Text>
      </FlexContainer>
    </Styled.Container>
  );
};

export default Header;
